import moment from 'moment';

export interface ArrStr {
  [key: string]: unknown;
  [index: number]: unknown;
}

export function filterEmptyStrings(data: any): any {
  const filteredData = Object.entries(data).filter(([, el]) => el === false || (el && el !== '') || el === 0);
  return Object.assign({}, ...filteredData.map(([key, val]) => ({ [key]: val })));
}

export function removeArrayItemByIndex(arr: any[], idx: number): any[] {
  return [...arr.slice(0, idx), ...arr.slice(idx + 1)];
}

export function parseDate(date: Date, format: string): string {
  return moment(date).format(format);
}

export function getVeryLastPage(currentPage: number, currentElementsNumber: number): number {
  if (currentElementsNumber === 1) {
    return currentPage === 0 ? 0 : currentPage - 1;
  }
  return currentPage;
}

export function removeDuplicatesFromListByProp(array: any[], prop: any): unknown[] {
  const arrayWithIds = array.map((item) => item[prop]);
  return array.filter(({ id }, index) => !arrayWithIds.includes(id, index + 1));
}

// source: https://stackoverflow.com/a/53771927

export function deepCopy(obj: any): any {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }

  if (obj instanceof Date) {
    return new Date(obj.getTime());
  }

  if (obj instanceof Array) {
    return obj.reduce((arr, item, i) => {
      arr[i] = deepCopy(item);
      return arr;
    }, []);
  }

  if (obj instanceof Object) {
    return Object.keys(obj).reduce((newObj: any, key: any) => {
      newObj[key as keyof typeof newObj] = deepCopy(obj[key as keyof typeof obj]);
      return newObj;
    }, {});
  }
}

export function createFormDataWithoutNulls(data: Record<string, any>): any {
  const fd = new FormData();
  Object.fromEntries(
    Object.entries(data).filter(([k, v]) => {
      if (v !== null && v !== undefined) {
        fd.append(k, v);
        return [k, v];
      }
    }),
  );
  return fd;
}

export function createFormDataWithMultiValueKey(key: string, values: any[]) {
  const fd = new FormData();
  values?.forEach((i) => fd.append('zalaczniki', i));
  return fd;
}
